import ControlCheckboxes from "components/Critics/ControlCheckboxes"
import AddHomeVideoReviewActions from "components/HomeVideoReviews/AddActions"
import HeaderPodsReviews from "components/HomeVideoReviews/HeaderPods"

import { ComponentProps } from "."
import Main from "./Main"
import { Wrapper } from "./styled"

const Add = ({
  areReviewsLoading,
  avForums,
  avNirvana,
  avsForum,
  bluRay,
  bluRayAuthority,
  digitalBits,
  doBlu,
  hidefDigest,
  highDefDiscNews,
  homeTheaterForum,
  onClear,
  onSetReview,
  reviewsControlCheckboxesProps,
  theaterByte,
  whySoBlu,
  addHomeVideoReviewActionsProps,
  mainProps
}: ComponentProps) => (
  <Wrapper>
    <ControlCheckboxes {...reviewsControlCheckboxesProps} />

    <HeaderPodsReviews
      areReviewsLoading={areReviewsLoading}
      avForums={avForums}
      avNirvana={avNirvana}
      avsForum={avsForum}
      bluRay={bluRay}
      bluRayAuthority={bluRayAuthority}
      digitalBits={digitalBits}
      doBlu={doBlu}
      hidefDigest={hidefDigest}
      highDefDiscNews={highDefDiscNews}
      homeTheaterForum={homeTheaterForum}
      isCompact={Boolean(
        reviewsControlCheckboxesProps.isCompactCheckboxProps?.checked
      )}
      left={<AddHomeVideoReviewActions {...addHomeVideoReviewActionsProps} />}
      onClear={onClear}
      onSetReview={onSetReview}
      theaterByte={theaterByte}
      whySoBlu={whySoBlu}
    />

    <Main {...mainProps} />
  </Wrapper>
)

Add.whyDidYouRender = true

export default Add
